export default __webpack_public_path__ + "static/media/Relocation.d7a51c28.svg";